const style = `
.dialog-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
}

.dialog-overlay {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .15);
}

.dialog {
    width: 600px;
    max-width: 100%;
    height: 300px;
    max-height: 100%;
    background-color: white;
    position: absolute;
    box-shadow: 1px 2px 8px #ccc;
}

@media(min-width: 600px) {
    .dialog {
        left: calc(50% - 300px);
    }
}

@media(min-height: 300px) {
    .dialog {
        top: calc(50% - 150px);
    }
}

.dialog .dialog__title {
    font-size: 1.5em;
    line-height: 2em;
    padding: 0 10px;
    background-color: #f4f4f4;
    box-sizing: border-box;
}

.dialog .dialog__title.information {
    color: #2196f3;
}

.dialog .dialog__title.error {
    color: #f44336;
}

.dialog .dialog__title.warning {
    color: #ff9800;
}

.dialog .dialog__message {
    padding: 10px;
    box-sizing: border-box;
}

.dialog .dialog__buttons {
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.dialog .dialog__buttons .button {
    display: inline-block;
}

.dialog .dialog__buttons .button .app_button_title {
    padding: 0;
}

`;
const elem = document.createElement("style");
elem.textContent = style;
document.head.appendChild(elem);